var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":_vm.size}},[(_vm.user.avatar !== null || _vm.user.avatar !== '')?_c('v-img',{attrs:{"src":_vm.avatarUrl,"alt":_vm.initials}}):_c('span',[_vm._v(_vm._s(_vm.initials))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }